import React from 'react';
import PropTypes from 'prop-types';

import RightPane from './RightPane';
import SettingsForm from './SettingsForm';
import * as BottomPane from './BottomPane';

import withToolsetPlaceholder from 'components/ToolsetPlaceholder';

const RandomizationHypothesisTestingComponent = props => (
  <div className="page-main__indent">
    <div className="flex">
      <div className="settings-width mb-15 mr-15">
        <SettingsForm />
      </div>

      {props.showRightAndBottomPanes &&
        <div className="graph-width mb-15">
          <RightPane />
        </div>
      }
    </div>

    {props.showRightAndBottomPanes &&
      <div className="mb-15">
        {props.primaryParameterType === 'numerical' &&
          props.secondaryParameterSelected &&
            <BottomPane.DoubleNumerical />
        }

        {props.primaryParameterType === 'numerical' &&
          !props.secondaryParameterSelected &&
            <BottomPane.Numerical />
        }

        {props.primaryParameterType === 'categorical' &&
          <BottomPane.Categorical />
        }
      </div>
    }
  </div>
);

RandomizationHypothesisTestingComponent.propTypes = {
  secondaryParameterSelected: PropTypes.bool.isRequired,
  showRightAndBottomPanes: PropTypes.bool.isRequired,
  primaryParameterType: PropTypes.string
};

RandomizationHypothesisTestingComponent.defaultProps = {
  primaryParameterType: null
};

export default withToolsetPlaceholder(
  RandomizationHypothesisTestingComponent
);
